import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Form, Modal, Button, Spin, Icon, Select, Input } from "antd";
import { getWithdraw, updateWithdraw } from "../../../actions/WithdrawAction";

const { Option } = Select;
const { TextArea } = Input;

class UpdateWithdraw extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        }
    }

    showUpdateModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    handleSubmit = (form) => {
        //Validate completed data
        form.validateFields((err, values) => {

            const updateWithdrawData = {
                Id: this.props.affiliateId,
                ...values
            };

            if (!err) {
                this.props.dispatch(updateWithdraw(updateWithdrawData, this.props.intl)).then((status) => {
                    if (status !== "error") {
                        this.setState({
                            visible: false
                        });
                        this.props.dispatch(getWithdraw(this.props.mainPartnerId, this.props.affiliateId, 1));
                    }
                })
            }
        });
    };

    render() {
        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;
        const { getFieldDecorator } = this.props.form;

        return (

            <React.Fragment>
                <Button type="primary" disabled={this.props.status !== 1} onClick={this.showUpdateModal}>
                    {this.props.intl.messages.update}
                </Button>

                <Modal
                    title={this.props.intl.messages.update}
                    visible={this.state.visible}
                    centered
                    onCancel={this.handleCancel}
                    footer={[
                        <div>
                            <Button onClick={this.handleCancel}
                                key="cancel">{this.props.intl.messages.cancel}</Button>
                            <Button key="save" onClick={this.handleSubmit.bind(this, this.props.form)}
                                type="primary">{this.props.intl.messages.update}</Button>
                        </div>
                    ]}
                >
                    <Spin indicator={antIcon} spinning={this.props.withdraw.inProcess}>

                        <form action="">
                            <Form.Item label={this.props.intl.messages.status}>
                                {getFieldDecorator('Status', {
                                    // initialValue: ,
                                })(
                                    <Select>
                                        <Option value="Approve">{this.props.intl.messages.approve}</Option>
                                        <Option value="Cancel">{this.props.intl.messages.cancel}</Option>
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.intl.messages.info}>
                                {getFieldDecorator('Info')(
                                    <TextArea rows={4} />
                                )}
                            </Form.Item>
                        </form>
                    </Spin>
                </Modal>
            </React.Fragment >
        );
    }
}

const mapStateToProps = state => {
    return {
        withdraw: state.withdraw
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(UpdateWithdraw)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Withdraw/UpdateWithdraw.js